// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Prospect_checks__IR-Dq {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}

.Prospect_success__8Ri6J {
  height: 27rem;
  margin-bottom: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Prospect/Prospect.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;AADF","sourcesContent":["@import \"../variables/breakpoints\";\n\n.checks {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 2rem;\n}\n\n.success {\n  height: 27rem;\n  margin-bottom: 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checks": `Prospect_checks__IR-Dq`,
	"success": `Prospect_success__8Ri6J`
};
export default ___CSS_LOADER_EXPORT___;
